import { render, staticRenderFns } from "./TheTeacherTopbar.vue?vue&type=template&id=480bd3ce&scoped=true"
import script from "./TheTeacherTopbar.vue?vue&type=script&lang=js"
export * from "./TheTeacherTopbar.vue?vue&type=script&lang=js"
import style0 from "./TheTeacherTopbar.vue?vue&type=style&index=0&id=480bd3ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480bd3ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480bd3ce')) {
      api.createRecord('480bd3ce', component.options)
    } else {
      api.reload('480bd3ce', component.options)
    }
    module.hot.accept("./TheTeacherTopbar.vue?vue&type=template&id=480bd3ce&scoped=true", function () {
      api.rerender('480bd3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/layout/TheTeacherTopbar.vue"
export default component.exports